module.exports = __webpack_public_path__ + "static/media/children-trust.1da67d6c.jpg";